import React from 'react';
import { motion } from 'framer-motion';
export function StackValue() {
  const items = [{
    name: 'TOMO 1 — El Mapa del Enemigo',
    val: '$990 UYU'
  }, {
    name: 'TOMO 2 — Derecho al Olvido',
    val: '$990 UYU'
  }, {
    name: 'TOMO 3 — El Escudo Legal',
    val: '$990 UYU'
  }, {
    name: 'TOMO 4 — Operativo Limpieza',
    val: '$990 UYU'
  }, {
    name: 'TOMO 5 — La Gran Quita',
    val: '$990 UYU'
  }, {
    name: 'TOMO 6 — Vida Post-Clearing',
    val: '$990 UYU'
  }];
  const bonos = [{
    name: 'BONO 1 — Kit de Arranque Rápido',
    val: '$490 UYU'
  }, {
    name: 'BONO 2 — Checklist de Errores',
    val: '$390 UYU'
  }, {
    name: 'BONO 3 — Planificador Semanal',
    val: '$390 UYU'
  }, {
    name: 'BONO 4 — Guía de Prioridades',
    val: '$390 UYU'
  }, {
    name: 'BONO 5 — Tracker 30 Días',
    val: '$390 UYU'
  }, {
    name: 'BONO 6 — Guía Respuestas Rápidas',
    val: '$390 UYU'
  }];
  return <section className="py-12 md:py-20 px-4 bg-brand-light" data-id="element-286">
      <div className="max-w-2xl mx-auto" data-id="element-287">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-dark border-2 border-gold/30 rounded-3xl p-6 md:p-10 shadow-gold-glow" data-id="element-288">
          <h2 className="text-2xl font-black text-white text-center mb-8 uppercase tracking-wide" data-id="element-289">
            RESUMEN DE TODO LO QUE RECIBÍS
          </h2>

          <div className="space-y-3 mb-6" data-id="element-290">
            {items.map((item, i) => <div key={i} className="flex justify-between items-center border-b border-gold/10 pb-2" data-id="element-291">
                <span className="text-cream/90 text-sm" data-id="element-292">{item.name}</span>
                <span className="text-gold/70 text-sm font-mono" data-id="element-293">
                  Valor: {item.val}
                </span>
              </div>)}
          </div>

          <div className="space-y-3 mb-8" data-id="element-294">
            {bonos.map((bono, i) => <div key={i} className="flex justify-between items-center border-b border-gold/10 pb-2" data-id="element-295">
                <span className="text-cream/90 text-sm" data-id="element-296">{bono.name}</span>
                <span className="text-gold/70 text-sm font-mono" data-id="element-297">
                  Valor: {bono.val}
                </span>
              </div>)}
          </div>

          <div className="text-center mb-8" data-id="element-298">
            <p className="text-cream/70 uppercase tracking-widest text-sm mb-1" data-id="element-299">
              VALOR TOTAL DEL PACK:
            </p>
            <p className="text-3xl font-black text-red-400 line-through" data-id="element-300">
              $8,370 UYU
            </p>
          </div>

          <div className="bg-brand-green border-2 border-gold rounded-2xl p-6 text-center shadow-gold-glow" data-id="element-301">
            <div className="mb-4 pb-4 border-b border-gold/20" data-id="element-302">
              <p className="text-cream text-sm uppercase tracking-widest mb-1" data-id="element-303">
                OFERTA PRINCIPAL — HOY:
              </p>
              <p className="text-4xl font-black text-gold-gradient" data-id="element-304">
                $690 UYU <span className="text-xl" data-id="element-305">✅</span>
              </p>
            </div>
            <div data-id="element-306">
              <p className="text-cream text-sm uppercase tracking-widest mb-1" data-id="element-307">
                OFERTA + BLINDAJE PRO — HOY:
              </p>
              <p className="text-4xl font-black text-gold-gradient" data-id="element-308">
                $990 UYU <span className="text-xl" data-id="element-309">🏆</span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}